<template>
  <div class="col-12" style="height:100%">

    <div v-if="exercise">
      <div class="portrait-mode" v-if="!IS_LANDSCAPE">
        <tabs v-if="!REST_TIME" type="primary" style="display: flex;
                flex-direction: column;" tab-nav-wrapper-classes="illustration-tabs-link" class="illustration-tabs">
          <tab-pane :label="$t('message.Animation')" style="text-align: center;">
            <div v-if="exercise && exercise.exercise && exercise.exercise.illustration && exercise.exercise.illustration.animation" style="height: 100%">
              <dynamic-video video-style="max-width: 100%;max-height: 100%; padding-bottom: 1em;" v-if="exercise.exercise.illustration.animation.hostingProvider == 'LOCAL'" :file-id="exercise.exercise.illustration.animation.id" :options="{ autoplay: true }" loop>
              </dynamic-video>
              <video v-else :src="exercise.exercise.illustration.animation" autoplay playsinline style="max-width: 100%;max-height: 100%; padding-bottom: 1em;" loop></video>
            </div>
          </tab-pane>

          <tab-pane :label="$t('message.Video')" style="text-align: center;">
            <div v-if="exercise && exercise.exercise && exercise.exercise.illustration && exercise.exercise.illustration.video" style="height: 100%">
              <dynamic-video video-style="max-width: 100%;max-height: 100%; padding-bottom: 1em;" v-if="exercise.exercise.illustration.video && exercise.exercise.illustration.video.hostingProvider == 'LOCAL'" :file-id="exercise.exercise.illustration.video.id" :options="{ autoplay: true }" loop>
              </dynamic-video>
              <video v-else :src="exercise.exercise.illustration.video" muted autoplay loop playsinline style="max-width: 100%;max-height: 100%; padding-bottom: 1em;"></video>
            </div>
          </tab-pane>

          <tab-pane :label="$t('message.Info')">
            <div style="height: 100%; padding-bottom: 1em; overflow: scroll;">
              <p v-if="exercise && exercise.exercise && exercise.exercise.illustration"> {{ exercise.exercise.illustration.info }}</p>
            </div>
          </tab-pane>
        </tabs>

        <div class="exercise-video col-12 text-center mt-5" v-if="!REST_TIME">
          <div v-if="exercise && exercise.exercise && exercise.exercise.illustration && exercise.exercise.illustration.aiReferenceImage && exercise.exercise.illustration.aiReferenceImage.id">
            <ai-yoga-tracker-vue :key="exercise.exercise.illustration.aiReferenceImage.id" :ai-reference-image="exercise.exercise.illustration.aiReferenceImage.id" :ai-threshold="this.exercise.exercise.illustration.aiThreshold" @result="aiResult"></ai-yoga-tracker-vue>
          </div>
        </div>

        <div class="text-center">
          <div class="row">
            <div class="col-12" style="width: 100%;">

              <div class="row">
                <div class="col-12" v-if="!REST_TIME">
                  <!-- Exercise details-->
                  <div class="row">
                    <div class="col-12 mt-2">
                      <h2 style="font-weight: 600" v-if="exercise.exercise.durationType == 'reps'">{{ exercise.duration }} reps</h2>
                      <h2 style="font-weight: 600" v-if="exercise.exercise.durationType == 'time' && !EXERCISE_INPROGRESS">{{ exercise.duration }} seconds</h2>
                    </div>

                    <div class="col-12" v-show="EXERCISE_INPROGRESS">
                      <div class="row">
                        <div class="col-12" v-if="exercise.exercise.durationType == 'time'">
                          <radial-progress-bar :diameter="100" :completed-steps="timeLeft" :total-steps="TIME_LIMIT">
                            {{ formatTime() }}
                          </radial-progress-bar>
                        </div>
                        <div class="col-12" v-if="exercise.exercise.durationType == 'reps'">

                        </div>
                      </div>

                    </div>
                  </div>

                  <!-- Exercise controls-->
                  <div class="row">

                    <div class="col-3">
                      <n-button v-if="currentExercise > 0" size="lg" round icon type="primary" simple style="border: none" @click.native="goToPreviousExercise()">
                        <i class="fa fa-chevron-left"></i>
                      </n-button>
                    </div>

                    <div class="col-6">

                      <n-button size="lg" round icon type="primary" @click.native="pauseTimer()" v-if="exercise.exercise.durationType == 'time' && EXERCISE_INPROGRESS && !EXERCISE_TIMER_PAUSED">
                        <i class="fa fa-pause"></i>
                      </n-button>

                      <n-button size="lg" round icon type="primary" @click.native="playTimer()" v-if="exercise.exercise.durationType == 'time' && EXERCISE_INPROGRESS && EXERCISE_TIMER_PAUSED">
                        <i class="fa fa-play"></i>
                      </n-button>

                      <n-button size="lg" round icon type="primary" @click.native="onRepsCompleted()" v-if="exercise.exercise.durationType == 'reps'">
                        <i class="fa fa-check"></i>
                      </n-button>
                    </div>
                    <div class="col-3">
                      <n-button v-if="currentExercise < exercises.length - 1" size="lg" round icon type="primary" simple style="border: none" @click.native="goToNextExercise()">
                        <i class="fa fa-chevron-right"></i>
                      </n-button>
                    </div>
                  </div>
                </div>
                <div class="col-12" v-if="REST_TIME">
                  <div class="row">
                    <div class="col-12">
                      <h5>{{ $t('message.REST') }}</h5>
                    </div>
                    <div class="col-12" style="font-size: 2rem;
                              font-weight: 600;color: var(--gray-dark);">
                      {{ formatRestTime() }}
                    </div>
                    <div class="col-12">
                      <n-button type="primary" round simple @click.native="skipRest()">
                        {{ $t('message.SKIP') }}
                      </n-button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="landscape-mode row justify-content-center" v-else>
        <div class="exercise-animation col-6 text-center" v-if="!REST_TIME">

          <tabs v-if="exercise && exercise.exercise && exercise.exercise.illustration && exercise.exercise.illustration.aiReferenceImage && exercise.exercise.illustration.aiReferenceImage.id" type="primary" style="display: flex; flex-direction: column;" tab-nav-wrapper-classes="illustration-tabs-link" class="illustration-tabs">
            <tab-pane :label="$t('message.Animation')" style="text-align: center;">
              <div class="h-100 " v-if="exercise && exercise.exercise && exercise.exercise.illustration && exercise.exercise.illustration.animation">
                <dynamic-video video-style="max-width: 100%;max-height: 100%; padding-bottom: 1em;" v-if="exercise.exercise.illustration.animation.hostingProvider == 'LOCAL'" :file-id="exercise.exercise.illustration.animation.id" :options="{ autoplay: true }" loop>
                </dynamic-video>
                <video v-else :src="exercise.exercise.illustration.animation" autoplay playsinline style="max-width: 100%;max-height: 100%; padding-bottom: 1em;" loop></video>
              </div>
            </tab-pane>

            <tab-pane :label="$t('message.Video')" style="text-align: center;">
              <div class="h-100" v-if="exercise && exercise.exercise && exercise.exercise.illustration && exercise.exercise.illustration.video">
                <dynamic-video video-style="max-width: 100%;max-height: 100%; padding-bottom: 1em;" v-if="exercise.exercise.illustration.video && exercise.exercise.illustration.video.hostingProvider == 'LOCAL'" :file-id="exercise.exercise.illustration.video.id" :options="{ autoplay: true }" loop>
                </dynamic-video>
                <video v-else :src="exercise.exercise.illustration.video" muted autoplay loop playsinline style="max-width: 100%;max-height: 100%; padding-bottom: 1em;"></video>
              </div>
            </tab-pane>
          </tabs>

          <div v-else>
            <dynamic-video video-style="max-width: 100%;max-height: 50vh; padding-bottom: 1em;" v-if="exercise.exercise.illustration.animation.hostingProvider == 'LOCAL'" :file-id="exercise.exercise.illustration.animation.id" :options="{ autoplay: true }" loop>
            </dynamic-video>
            <video v-else :src="exercise.exercise.illustration.animation" autoplay playsinline style="max-width: 100%;max-height: 100%; padding-bottom: 1em;" loop></video>
          </div>
        </div>

        <div class="exercise-video col-6 text-center" v-if="!REST_TIME">
          <div v-if="exercise && exercise.exercise && exercise.exercise.illustration && exercise.exercise.illustration.aiReferenceImage && exercise.exercise.illustration.aiReferenceImage.id">
            <ai-yoga-tracker-vue :key="exercise.exercise.illustration.aiReferenceImage.id" :ai-reference-image="exercise.exercise.illustration.aiReferenceImage.id" :ai-threshold="this.exercise.exercise.illustration.aiThreshold" @result="aiResult"></ai-yoga-tracker-vue>
          </div>
          <div v-else>
            <dynamic-video video-style="max-width: 100%;max-height: 50vh; padding-bottom: 1em;" v-if="exercise.exercise.illustration.video && exercise.exercise.illustration.video.hostingProvider == 'LOCAL'" :file-id="exercise.exercise.illustration.video.id" :options="{ autoplay: true }" loop>
            </dynamic-video>
            <video v-else :src="exercise.exercise.illustration.video" muted autoplay loop playsinline style="max-width: 100%;max-height: 100%; padding-bottom: 1em;"></video>
          </div>
        </div>

        <div class="exercise-info col-6" v-if="!REST_TIME">
          <div style="height: 100%; padding-bottom: 1em; overflow: auto;">
            <p v-if="exercise && exercise.exercise && exercise.exercise.illustration"> {{ exercise.exercise.illustration.info }}</p>
          </div>
        </div>

        <div class="text-center col-6">
          <div class="row">
            <div class="col-12" style="width: 100%;">

              <div class="row">
                <div class="col-12" v-if="!REST_TIME">
                  <!-- Exercise details-->
                  <div class="row">
                    <div class="col-12 mt-2">
                      <h2 style="font-weight: 600" v-if="exercise.exercise.durationType == 'reps'">{{ exercise.duration }} reps</h2>
                      <h2 style="font-weight: 600" v-if="exercise.exercise.durationType == 'time' && !EXERCISE_INPROGRESS">{{ exercise.duration }} seconds</h2>
                    </div>

                    <div class="col-12" v-show="EXERCISE_INPROGRESS">
                      <div class="row">
                        <div class="col-12" v-if="exercise.exercise.durationType == 'time'">
                          <radial-progress-bar :diameter="100" :completed-steps="timeLeft" :total-steps="TIME_LIMIT">
                            {{ formatTime() }}
                          </radial-progress-bar>
                        </div>
                        <div class="col-12" v-if="exercise.exercise.durationType == 'reps'">

                        </div>
                      </div>

                    </div>
                  </div>

                  <!-- Exercise controls-->
                  <div class="row">

                    <div class="col-3">
                      <n-button v-if="currentExercise > 0" size="lg" round icon type="primary" simple style="border: none" @click.native="goToPreviousExercise()">
                        <i class="fa fa-chevron-left"></i>
                      </n-button>
                    </div>

                    <div class="col-6">

                      <n-button size="lg" round icon type="primary" @click.native="pauseTimer()" v-if="exercise.exercise.durationType == 'time' && EXERCISE_INPROGRESS && !EXERCISE_TIMER_PAUSED">
                        <i class="fa fa-pause"></i>
                      </n-button>

                      <n-button size="lg" round icon type="primary" @click.native="playTimer()" v-if="exercise.exercise.durationType == 'time' && EXERCISE_INPROGRESS && EXERCISE_TIMER_PAUSED">
                        <i class="fa fa-play"></i>
                      </n-button>

                      <n-button size="lg" round icon type="primary" @click.native="onRepsCompleted()" v-if="exercise.exercise.durationType == 'reps'">
                        <i class="fa fa-check"></i>
                      </n-button>
                    </div>
                    <div class="col-3">
                      <n-button v-if="currentExercise < exercises.length - 1" size="lg" round icon type="primary" simple style="border: none" @click.native="goToNextExercise()">
                        <i class="fa fa-chevron-right"></i>
                      </n-button>
                    </div>
                  </div>
                </div>
                <div class="col-12" v-if="REST_TIME">
                  <div class="row">
                    <div class="col-12">
                      <h5>{{ $t('message.REST') }}</h5>
                    </div>
                    <div class="col-12" style="font-size: 2rem;
                              font-weight: 600;color: var(--gray-dark);">
                      {{ formatRestTime() }}
                    </div>
                    <div class="col-12">
                      <n-button type="primary" round simple @click.native="skipRest()">
                        {{ $t('message.SKIP') }}
                      </n-button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <card v-if="REST_TIME && exercises[currentExercise + 1] && exercises[currentExercise + 1].name">
      <div slot="header" class="card-title" style="font-weight: 500;font-weight: 600;">
        <span>{{ $t('message.confirmbooking14') }}</span>
        <h5>
          {{ exercises[currentExercise + 1].name }}
        </h5>
      </div>

      <video :src="exercises[currentExercise + 1].exercise.illustration.animation" autoplay style="width: 100%;max-height: 100%;" playsinline loop></video>
    </card>

    <!-- Exercise start countdown -->
    <div class="exercise-countdown" style="    background-color: #fffbfbd6;position: absolute;height: 100%;top: 0px;width: 100%;right: 0px;backdrop-filter: blur(1rem);display: grid;place-items: center;" v-if="exercise && showExerciseStartCountdown">
      <div class="countdown">
        <div class="number">
          <h2>{{ $t('message.Ready') }}</h2>
        </div>

        <div class="number">
          <h2>3</h2>
        </div>

        <div class="number">
          <h2>2</h2>
        </div>

        <div class="number">
          <h2>1</h2>
        </div>

        <div class="number">
          <h2>{{ $t('message.Go') }}</h2>
        </div>
      </div>
    </div>

    <audio src="@/assets/audio/start-countdown.mp3" ref="startCountdownAudio"> </audio>

    <modal :show.sync="EXERCISES_COMPLETED" headerClasses="justify-content-center" modalClasses="full-screen-modal" :show-close="false">
      <h4 slot="header" class="title title-up">{{ $t('message.Congratulations') }}</h4>
      <!-- Confetti -->
      <div class="confet-wrapper" style="z-index: 1">
        <div class="confetti-149"></div>
        <div class="confetti-148"></div>
        <div class="confetti-147"></div>
        <div class="confetti-146"></div>
        <div class="confetti-145"></div>
        <div class="confetti-144"></div>
        <div class="confetti-143"></div>
        <div class="confetti-142"></div>
        <div class="confetti-141"></div>
        <div class="confetti-140"></div>
        <div class="confetti-139"></div>
        <div class="confetti-138"></div>
        <div class="confetti-137"></div>
        <div class="confetti-136"></div>
        <div class="confetti-135"></div>
        <div class="confetti-134"></div>
        <div class="confetti-133"></div>
        <div class="confetti-132"></div>
        <div class="confetti-131"></div>
        <div class="confetti-130"></div>
        <div class="confetti-129"></div>
        <div class="confetti-128"></div>
        <div class="confetti-127"></div>
        <div class="confetti-126"></div>
        <div class="confetti-125"></div>
        <div class="confetti-124"></div>
        <div class="confetti-123"></div>
        <div class="confetti-122"></div>
        <div class="confetti-121"></div>
        <div class="confetti-120"></div>
        <div class="confetti-119"></div>
        <div class="confetti-118"></div>
        <div class="confetti-117"></div>
        <div class="confetti-116"></div>
        <div class="confetti-115"></div>
        <div class="confetti-114"></div>
        <div class="confetti-113"></div>
        <div class="confetti-112"></div>
        <div class="confetti-111"></div>
        <div class="confetti-110"></div>
        <div class="confetti-109"></div>
        <div class="confetti-108"></div>
        <div class="confetti-107"></div>
        <div class="confetti-106"></div>
        <div class="confetti-105"></div>
        <div class="confetti-104"></div>
        <div class="confetti-103"></div>
        <div class="confetti-102"></div>
        <div class="confetti-101"></div>
        <div class="confetti-100"></div>
        <div class="confetti-99"></div>
        <div class="confetti-98"></div>
        <div class="confetti-97"></div>
        <div class="confetti-96"></div>
        <div class="confetti-95"></div>
        <div class="confetti-94"></div>
        <div class="confetti-93"></div>
        <div class="confetti-92"></div>
        <div class="confetti-91"></div>
        <div class="confetti-90"></div>
        <div class="confetti-89"></div>
        <div class="confetti-88"></div>
        <div class="confetti-87"></div>
        <div class="confetti-86"></div>
        <div class="confetti-85"></div>
        <div class="confetti-84"></div>
        <div class="confetti-83"></div>
        <div class="confetti-82"></div>
        <div class="confetti-81"></div>
        <div class="confetti-80"></div>
        <div class="confetti-79"></div>
        <div class="confetti-78"></div>
        <div class="confetti-77"></div>
        <div class="confetti-76"></div>
        <div class="confetti-75"></div>
        <div class="confetti-74"></div>
        <div class="confetti-73"></div>
        <div class="confetti-72"></div>
        <div class="confetti-71"></div>
        <div class="confetti-70"></div>
        <div class="confetti-69"></div>
        <div class="confetti-68"></div>
        <div class="confetti-67"></div>
        <div class="confetti-66"></div>
        <div class="confetti-65"></div>
        <div class="confetti-64"></div>
        <div class="confetti-63"></div>
        <div class="confetti-62"></div>
        <div class="confetti-61"></div>
        <div class="confetti-60"></div>
        <div class="confetti-59"></div>
        <div class="confetti-58"></div>
        <div class="confetti-57"></div>
        <div class="confetti-56"></div>
        <div class="confetti-55"></div>
        <div class="confetti-54"></div>
        <div class="confetti-53"></div>
        <div class="confetti-52"></div>
        <div class="confetti-51"></div>
        <div class="confetti-50"></div>
        <div class="confetti-49"></div>
        <div class="confetti-48"></div>
        <div class="confetti-47"></div>
        <div class="confetti-46"></div>
        <div class="confetti-45"></div>
        <div class="confetti-44"></div>
        <div class="confetti-43"></div>
        <div class="confetti-42"></div>
        <div class="confetti-41"></div>
        <div class="confetti-40"></div>
        <div class="confetti-39"></div>
        <div class="confetti-38"></div>
        <div class="confetti-37"></div>
        <div class="confetti-36"></div>
        <div class="confetti-35"></div>
        <div class="confetti-34"></div>
        <div class="confetti-33"></div>
        <div class="confetti-32"></div>
        <div class="confetti-31"></div>
        <div class="confetti-30"></div>
        <div class="confetti-29"></div>
        <div class="confetti-28"></div>
        <div class="confetti-27"></div>
        <div class="confetti-26"></div>
        <div class="confetti-25"></div>
        <div class="confetti-24"></div>
        <div class="confetti-23"></div>
        <div class="confetti-22"></div>
        <div class="confetti-21"></div>
        <div class="confetti-20"></div>
        <div class="confetti-19"></div>
        <div class="confetti-18"></div>
        <div class="confetti-17"></div>
        <div class="confetti-16"></div>
        <div class="confetti-15"></div>
        <div class="confetti-14"></div>
        <div class="confetti-13"></div>
        <div class="confetti-12"></div>
        <div class="confetti-11"></div>
        <div class="confetti-10"></div>
        <div class="confetti-9"></div>
        <div class="confetti-8"></div>
        <div class="confetti-7"></div>
        <div class="confetti-6"></div>
        <div class="confetti-5"></div>
        <div class="confetti-4"></div>
        <div class="confetti-3"></div>
        <div class="confetti-2"></div>
        <div class="confetti-1"></div>
        <div class="confetti-0"></div>
      </div>

      <img src="@/assets/img/trophy.gif" style="position: absolute;
                top: 0;
                left: 50%;
                transform: translate(-50%, 0)" />
      <template slot="footer">
        <div class="col-12 text-center mt-5">
          <n-button type="primary" v-if="$store.state.trainingType == 'fitness'" round size="lg" style="font-weight: 600" @click.native="viewReport">{{ $t('message.CHECK WORKOUT REPORT') }}</n-button>
          <n-button type="primary" v-else round size="lg" style="font-weight: 600" @click.native="viewReport">{{ $t('message.CHECK WORKOUT REPORT') }}</n-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { TabPane, Tabs } from "src/components";
import RadialProgressBar from "vue-radial-progress";
import { mapState } from "vuex";
import "@/assets/sass/confetti.scss";
import AiYogaTrackerVue from "../components/AiYogaTracker.vue";

export default {
  name: "videos",

  components: {
    TabPane,
    Tabs,
    RadialProgressBar,
    AiYogaTrackerVue,
  },

  data() {
    return {
      IS_LANDSCAPE: false,
      LOADING: true,
      selectedVideo: null,
      playerVars: {
        autopla: 1,
        modestbranding: 1,
      },
      exercise: null,
      EXERCISE_INPROGRESS: false,
      currentExercise: 0,

      //Timer
      TIME_LIMIT: 0,
      timePassed: 0,
      timeLeft: 0,
      timerInterval: null,

      //Rest timer
      restTimer: {
        TIME_LIMIT: 30,
        timePassed: 0,
        timeLeft: 30,
        timerInterval: null,
      },

      //Start timer
      startTimer: {
        completedTime: 0,
        totalTime: 5,
      },
      exerciseStartCountdownText: "Ready",
      showExerciseStartCountdown: true,
      REST_TIME: false,

      EXERCISES_COMPLETED: false,
      EXERCISE_TIMER_PAUSED: false,
      tracker: null,
    };
  },

  async mounted() {
    this.$root.onBackButton = () => {
      if (this.$store.state.trainingType == "yoga") {
        this.$router.push("/yogaschedule");
      } else {
        this.$router.push("/fitnessschedule");
      }
    };

    this.IS_LANDSCAPE = screen.availHeight < screen.availWidth;

    window.addEventListener("orientationchange", () => {
      this.IS_LANDSCAPE = screen.availHeight < screen.availWidth;
    });

    this.startExercise();
  },
  beforeRouteLeave(to, from, next) {
    swal.fire({
      title: this.$t("message.Are you sure?"),
      text: this.$t("message.Current progress will be discarded"),
      confirmButtonText: this.$t("message.Yes, Cancel"),
      showCancelButton: true,
      cancelButtonText: this.$t("message.No"),
    })
      .then(async (result) => {
        if (result && result.value) {
          next();
        }
      });
  },

  beforeDestroy() {
    this.$root.onBackButton = null;
    clearTimeout(this.timerInterval);
  },

  computed: {
    ...mapState({
      training: (state) => state.training,
      exercises: (state) => state.exercisesForCurrentDay,
      currentTrainingDayIndex: (state) => state.currentTrainingDayIndex,
    }),
    user() {
      return JSON.parse(localStorage.user);
    },
    caregroup() {
      return this.$store.state.caregroup;
    },
    player() {
      return this.$refs.youtube.player;
    },
  },
  methods: {
    aiResult(result) {
      if (result) {
        if (this.EXERCISE_TIMER_PAUSED) {
          this.playTimer();
        }
      } else {
        this.pauseTimer();
      }
    },
    startTracker() {
      let trackerFunction = "startFitnessTracker";
      if (this.$store.state.trainingType == "yoga") {
        trackerFunction = "startYogaTracker";
      }
      this.$store.dispatch(trackerFunction, {
        exerciseId: this.exercise.exercise._id,
      });
    },
    async stopTracker() {
      let trackerFunction = "stopFitnessTracker";
      if (this.$store.state.trainingType == "yoga") {
        trackerFunction = "stopYogaTracker";
      }
      this.tracker = await this.$store.dispatch(trackerFunction, {
        exerciseId: this.exercise.exercise._id,
      });

      //Schedule local notification reminder for next fitness Schedule on last exercise
      let isLastExercise = false;
      let lastExercise = this.exercises[this.exercises.length - 1];
      if (
        lastExercise &&
        lastExercise.exercise._id &&
        lastExercise.exercise._id == this.exercise.exercise._id
      ) {
        isLastExercise = true;
      }

      if (isLastExercise) {
        cordova.plugins.notification.local.getScheduled((res) => {
          let title = `Fitness - ${this.training.title}`;
          let text = `Continue workout for ${this.training.days[this.currentTrainingDayIndex].name
            }`;
          let data = "fitness notification";
          if (this.$store.state.trainingType == "yoga") {
            title = `Yoga - ${this.training.title}`;
            text = `Continue practice for ${this.training.days[this.currentTrainingDayIndex].name
              }`;
            data = "yoga notification";
          }

          if (this.currentTrainingDayIndex == 0) {
            text = `Start ${this.training.days[this.currentTrainingDayIndex].name
              } workout`;
            if (this.$store.state.trainingType == "yoga") {
              text = `Start ${this.training.days[this.currentTrainingDayIndex].name
                } practice`;
            }
          }

          for (let notification of res) {
            if (
              notification &&
              notification.title == title &&
              notification.text == text
            ) {
              cordova.plugins.notification.local.cancel(
                notification.id,
                (res) => {
                  console.log("cancel", res);
                }
              );
            }
          }

          if (
            this.training.days[this.currentTrainingDayIndex + 1] &&
            this.training.days[this.currentTrainingDayIndex + 1].name &&
            localStorage[title]
          ) {
            text = `Continue workout for ${this.training.days[this.currentTrainingDayIndex + 1].name
              }`;
            if (this.$store.state.trainingType == "yoga") {
              text = `Continue practice for ${this.training.days[this.currentTrainingDayIndex + 1].name
                }`;
            }
            let time = JSON.parse(localStorage[title]);

            let id = 0;
            if (localStorage.remindersId) {
              id = Number(localStorage.remindersId);
            }
            cordova.plugins.notification.local.schedule({
              title: title,
              text: text,
              id: id,
              trigger: { every: time },
              foreground: true,
              autoClear: false,
              data: data,
            });
            id++;
            localStorage.remindersId = id;
          }
        });
      }
    },
    goToPreviousExercise() {
      this.currentExercise--;
      clearInterval(this.timerInterval);
      this.startExercise();
    },
    goToNextExercise() {
      this.stopTracker();
      this.currentExercise++;
      clearInterval(this.timerInterval);
      this.startExercise();
    },
    skipRest() {
      this.onRestTimesUp();
    },
    playTimer() {
      this.startExerciseTimer();
      this.EXERCISE_TIMER_PAUSED = false;
    },
    pauseTimer() {
      this.EXERCISE_TIMER_PAUSED = true;
      clearInterval(this.timerInterval);
    },
    onRepsCompleted() {
      this.stopTracker();
      this.currentExercise++;
      if (this.exercises[this.currentExercise]) {
        this.startExercise();
      } else {
        this.EXERCISES_COMPLETED = true;
      }
    },
    startExercise() {
      let that = this;
      this.EXERCISE_INPROGRESS = true;

      //Init timer variables
      this.TIME_LIMIT = 0;
      this.timePassed = 0;
      this.timeLeft = 0;

      this.exercise = this.exercises[this.currentExercise];

      this.setAppHeaderText(this.exercise.exercise.name);

      if (this.exercise.exercise.durationType == "time") {
        this.showExerciseStartCountdown = true;
        that.$refs.startCountdownAudio.play();
        setTimeout(() => {
          that.exerciseStartCountdownText = "Go";
        }, 1000);

        setTimeout(() => {
          that.showExerciseStartCountdown = false;
          that.startExerciseTimer();
        }, 5000);
        this.TIME_LIMIT = this.exercise.duration;
        this.timeLeft = this.TIME_LIMIT;

        this.startTracker();
      } else {
        this.showExerciseStartCountdown = true;
        that.$refs.startCountdownAudio.play();
        setTimeout(() => {
          that.exerciseStartCountdownText = "Go";
        }, 1000);
        setTimeout(() => {
          that.showExerciseStartCountdown = false;
        }, 5000);
        this.startTracker();
      }
    },
    selectVideo(video) {
      this.selectedVideo = video;
      this.$forceUpdate();
    },
    goToTraining(trainingId) {
      alert();
      this.$router.push("/training");
    },

    //timer
    formatTime() {
      let time = this.timeLeft;
      const minutes = Math.floor(time / 60);
      let seconds = time % 60;

      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      return `${minutes}:${seconds}`;
    },
    formatRestTime() {
      let time = this.restTimer.timeLeft;
      const minutes = Math.floor(time / 60);
      let seconds = time % 60;

      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      return `${minutes}:${seconds}`;
    },
    initTimer() {
      this.TIME_LIMIT = 20;
      this.timePassed = 0;
      this.timeLeft = 20;
      this.timerInterval = null;
    },
    onTimesUp() {
      this.stopTracker();
      if (this.currentExercise < this.exercises.length - 1) {
        this.startRestTimer();
      } else {
        this.EXERCISES_COMPLETED = true;
      }
      this.EXERCISE_INPROGRESS = false;
      clearInterval(this.timerInterval);
    },

    onRestTimesUp() {
      this.REST_TIME = false;
      this.EXERCISE_INPROGRESS = true;
      clearInterval(this.restTimer.timerInterval);
      this.restTimer.timePassed = 0;
      this.restTimer.timeLeft = 30;

      this.currentExercise++;

      if (this.exercises[this.currentExercise]) {
        this.startExercise();
      } else {
        this.EXERCISES_COMPLETED = true;
      }
    },
    startExerciseTimer() {
      let that = this;
      this.timerInterval = setInterval(() => {
        that.timePassed = that.timePassed += 1;
        that.timeLeft = that.TIME_LIMIT - that.timePassed;

        if (that.timeLeft === 0) {
          that.onTimesUp();
        }
      }, 1000);
    },

    startRestTimer() {
      this.REST_TIME = true;
      let that = this;
      this.restTimer.timerInterval = setInterval(() => {
        that.restTimer.timePassed = that.restTimer.timePassed += 1;
        that.restTimer.timeLeft =
          that.restTimer.TIME_LIMIT - that.restTimer.timePassed;

        if (that.restTimer.timeLeft === 0) {
          that.onRestTimesUp();
        }
      }, 1000);
    },

    viewReport() {
      this.$store.commit("setState", {
        stateName: "fitnessOrYogaReport",
        stateValue: {
          ...this.tracker.trainingTracker.daysTracker[
          this.tracker.trainingTracker.daysTracker.length - 1
          ],
          training: this.tracker.trainingTracker.training,
        },
      });
      this.$router.push("viewfitnessandyogareports");
    },
  },
};
</script>

<style scoped>
/deep/ .radial-progress-container {
  margin: auto;
}

/deep/ .illustration-tabs-link {
  order: 2;
}

/deep/ .illustration-tabs ul.nav.nav-pills {
  justify-content: space-between;
}

/deep/ .illustration-tabs .nav-pills .nav-item .nav-link {
  padding: 10px 22px;
  /* border: 1px solid; */
}

/deep/ .illustration-tabs .tab-content {
  height: 27rem;
}

/deep/.illustration-tabs .tab-space {
  padding-bottom: 0px;
  height: 50vh;
}

@media (orientation: landscape) {
  /deep/.illustration-tabs .tab-space {
    height: 50vh;
  }
}

@media (orientation: portrait) {
  /deep/.illustration-tabs .tab-space {
    height: 40vh;
  }
}

/deep/ .btn.btn-icon.btn-lg {
  height: 5.6rem;
  width: 5.6rem;
  border-radius: 50%;
}

#order-med-card {
  background-size: cover;
  background-repeat: no-repeat;
}

/deep/ iframe {
  width: 100%;
  height: 16em;
}

.video-thumbnail {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid #d6d0d0;
}

.playing-video-title {
  font-weight: 600;
  margin-top: 1rem;
}

.videos-list {
  overflow-y: scroll;
  height: 54vh;
}

/deep/.el-loading-spinner {
  position: fixed;
}

/deep/ .el-loading-mask {
  background: #fff !important;
}

@media (min-width: 992px) {
  iframe {
    height: 31em;
  }
}

@media (min-height: 736px) {
  /deep/ iframe {
    height: 35vh;
  }

  .videos-list {
    height: 40vh;
  }
}

@media (min-height: 768px) {
  /deep/ iframe {
    height: 40vh;
  }

  .videos-list {
    height: 40vh;
  }
}

@media (min-height: 1024px) {
  iframe {
    height: 31em;
  }

  .videos-list {
    height: 46vh;
  }
}

/*Exercise start countdown*/

.countdown {
  position: relative;
  width: 100%;
  height: 400px;
  transform-style: preserve-3d;
  perspective: 1000px;
}

.countdown:before {
  content: "";
  position: absolute;
  bottom: -50px;
  left: 0;
  width: 100%;
  height: 10px;
  background: #000;
  border-radius: 50%;
  filter: blur(14px);
  animation: shadow 1s linear infinite;
}

@keyframes shadow {

  0%,
  100% {
    transform: scale(0.5);
  }

  50% {
    transform: scale(1);
  }
}

.countdown .number {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotateY(270deg);
  animation: animate 6s linear infinite;
}

.countdown .number:nth-child(1) {
  animation-delay: 0s;
}

.countdown .number:nth-child(2) {
  animation-delay: 1s;
}

.countdown .number:nth-child(3) {
  animation-delay: 2s;
}

.countdown .number:nth-child(4) {
  animation-delay: 3s;
}

.countdown .number:nth-child(5) {
  animation-delay: 4s;
}

.countdown .number h2 {
  margin: 0;
  padding: 0;
  font-size: 8em;
  color: var(--color-primary);
}

@keyframes animate {
  0% {
    transform: rotateY(90deg);
  }

  10%,
  100% {
    transform: rotateY(-90deg);
  }
}
</style>
